import styled from 'styled-components';

const Styled = {
  Flex: styled.div`
    display: flex;
    align-items: ${props => (props.align || 'stretch')};
    justify-content: ${props => (props.justify || 'flex-start')};

    input {
      &:nth-child(2) {
        margin-left: 10px;
      }
    }
  `,
};

export default Styled;




// WEBPACK FOOTER //
// ./src/components/StyledComponents.js